import type { Difference } from '../types';

export function isHit(difference: Difference, x: number, y: number, widthPx: number, heightPx: number): boolean {
  const minX = 44 / Math.max(widthPx, 1);
  const minY = 44 / Math.max(heightPx, 1);
  if (difference.shape === 'rect') {
    const halfW = Math.max((difference.w ?? .1) / 2, minX / 2);
    const halfH = Math.max((difference.h ?? .1) / 2, minY / 2);
    return Math.abs(x - difference.x) <= halfW && Math.abs(y - difference.y) <= halfH;
  }
  const radiusX = Math.max(difference.radius ?? .05, minX / 2);
  const radiusY = Math.max(difference.radius ?? .05, minY / 2);
  return ((x - difference.x) / radiusX) ** 2 + ((y - difference.y) / radiusY) ** 2 <= 1;
}
